import { Box, Typography } from "@mui/material";
import { Trans } from "react-i18next";
import { Flex } from "../../../../base/components/Flex";
import { useTranslationPrefix } from "../../../../hooks/useTranslationPrefix";
import QrButton from "../components/QrButton";
import QrPageLogo from "../components/QrPageLogo";

interface Props {
  onYesClick: () => void;
  onNoClick: () => void;
}

const QrCertificateStep = ({ onYesClick, onNoClick }: Props) => {
  const { _t } = useTranslationPrefix("LaunchPlaylistQrPageNew");

  return (
    <Flex
      flexDirection="column"
      width="100%"
      minHeight="100%"
      alignItems="center"
      gap={2}
      px={{ xs: 2, md: 6 }}
    >
      <Flex
        flexDirection="column"
        width="100%"
        alignItems={{ xs: "center", md: "end" }}
      >
        <QrPageLogo />
      </Flex>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, auto)",
          columnGap: { xs: 2, sm: 4 },
          rowGap: 6,
          alignItems: "center",
          marginY: "auto",
        }}
      >
        <Typography
          textAlign="center"
          sx={{ gridColumnStart: 1, gridColumnEnd: 3 }}
          fontSize="1.5rem"
        >
          <Trans
            i18nKey="LaunchPlaylistQrPageNew.doYouWidhToReceiveCertificate"
            defaults={
              "Check the URL to make sure there are no typing errors. <br /> If you thing this page should work, contact us at novikov@cie-group.cz"
            }
          >
            <strong></strong>
          </Trans>
        </Typography>
        <Typography
          textTransform="uppercase"
          fontWeight={700}
          fontSize={{ xs: "1.5rem", md: "3rem" }}
        >
          {_t("certificateYes", "Yes")}
        </Typography>

        <QrButton id="cert-sign-up" color="primary" onClick={onYesClick}>
          {_t("certificateSignUp", "Sign up")}
        </QrButton>
        <Typography
          textTransform="uppercase"
          fontWeight={700}
          fontSize={{ xs: "1.5rem", md: "3rem" }}
        >
          {_t("certificateNo", "No")}
        </Typography>
        <QrButton id="cert-annonym" color="primary" onClick={onNoClick}>
          {_t("certificateAnnonymous", "Annonymous")}
        </QrButton>
      </Box>
      <Box height="3rem"></Box>
    </Flex>
  );
};

export default QrCertificateStep;
